<template>
  <!-- <div class="page">
    <div class="top-logo" @click="$gopage('index')">
      <img src="~images/logo-login.png">
      <span>朗朗书声</span>
    </div>
    <div class="container">
      <div class="cont">
        <div class="login-box">
          <h3 class="bindTit">绑定手机，便于下次快速登录</h3>
          <div class="form-box">
            <div class="form-item">
              <FInput ref="mobile" v-model="formData.mobile" :maxlength="11" type="text" placeholder="请输入手机号" />
            </div>
            <div class="form-item form-item-vcode">
              <div class="item-code">
                <FInput :showDel="false" v-model="formData.code" ref="code" :maxlength="6" type="text" placeholder="请输入6位短信验证码">
                  <button class="btn btn-code" :class="{disabled: !canSend}" v-text="btnText" @click="getCode"></button>
                </FInput>
              </div>
            </div>
            <button
              class="btn btn-act"
              @click="submit"
              :class="{ 'btn-disabled': !isCanClick }"
            >
              登录并绑定手机
            </button>
            <div class="bindTips">
                <span class="xin">*</span> 首次使用“微信扫码登录”，需要绑定手机号，建议使用 “朗朗书声”账号同个手机号作为绑定手机号
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="copy">Copyright @ 2020 朗朗书声 All Right Reserved 京ICP备19040061号</div>
      <div class="wj">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926" style="display:inline-block;">
          <img src="~images/icon-wj.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">京公网安备 11010502040926号</p>
        </a>
      </div>
    </div>
  </div> -->

  <LoginModule>
    <div class="back flex" @click="goBack">
      <span class="iconfont fanhui1"></span>
      返回
    </div>
    <h2 class="title">绑定手机，便于下次快捷登录</h2>
    <div class="contBox">
      <div class="item">
        <FInput
          class="ipt"
          ref="mobile"
          :maxlength="11"
          v-model="formData.mobile"
          type="text"
          placeholder="请输入手机号"
        />
      </div>
      <div class="item">
        <FInput
          class="ipt"
          ref="code"
          :maxlength="6"
          v-model="formData.code"
          type="text"
          placeholder="请输入验证码"
        >
          <button
            class="btn btn-code"
            :class="{ disabled: !canSend }"
            v-text="btnText"
            @click="getCode"
          ></button>
        </FInput>
      </div>
      <button
        class="summit btn btn-act"
        @click="submit"
        :class="{ 'btn-disabled': !isCanClick }"
      >
        登录并绑定手机号
      </button>
      <div class="login-tip">
        *首次使用“微信扫码登录”，需要绑定手机号，</br>
        建议使用“朗朗书声”账号同个手机号作为绑定手机号
      </div>
    </div>
    <CodeValid ref="codeValid" @confirm="codeConfirm" v-model="showValidCode" />
  </LoginModule>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import FInput from "base/input/index";
import CodeValid from "business/CodeValid";
import mixin_user from "mixin/user";
import Vue from "vue";
import md5 from "md5";
import LoginModule from "./loginModule.vue";

export default {
  components: {
    FInput,
    CodeValid,
    LoginModule,
  },
  mixins: [mixin_user],
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  data() {
    return {
      isCanClick: false,
      smsType: 3,
      formData: {
        mobile: "",
        code: "",
        pwd: "",
        captcha: "",
      },
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        this.isCanClick = newVal.mobile && newVal.code;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async submit() {
      if (!this.isCanClick) {
        return;
      }
      const formData = this.formData;
      if (!this.isCanClick) {
        return;
      }
      const config = [
        {
          id: "mobile",
          rule: {
            required: {
              message: "请输入手机号码",
            },
            mobile: {
              message: "请输入正确的手机号码",
            },
          },
        },
        {
          id: "code",
          rule: {
            required: {
              message: "请输入验证码",
            },
          },
        },
      ];
      let { result } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      let query = this.$route.query;
      this.$loading.show();
      const params = {
        mobile: formData.mobile,
        code: formData.code,
        ticket: query?.ticket,
      };
      const res = await this.$post("/webLogin/mobileLogin.json", params);
      if (res.status == 200) {
        this.formData.mobile = "";
        this.formData.code = "";
        this.$toast("登录成功!");
        if (res.data) {
          this.$store.dispatch("setUserInfo", res.data);
        }
        // this.$user.loginCallBack(query);
        this.goJumpNext();
      } else {
        this.$toast(res.message);
      }
      this.$loading.hide();
    },
  },
};
</script>
<style lang="less" scoped>
@import "~styles/user/index.less";

.title {
  font-size: 24px;
}
.contBox{

  .login-tip {
    margin-top:62px;
  }
}
</style>
